import { Component, Input, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { SPINNER_AREA } from '../../model/common.model';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule,NgxSpinnerComponent],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent implements OnInit{
@Input() spinnerName:string = SPINNER_AREA['FullScreen'];
@Input() fullScreen = false;

public beginRender = false;

ngOnInit(){
  this.beginRender = true
}
}
